export default { //eslint-disable-line
  NODE_ENV: 'dev',
  //ROOT_API: 'https://api.fiqueok.seuapoio0800.com.br' //'http://localhost:8090'
  //ROOT_API: 'http://localhost:8090'
  ROOT_API: 'https://api.vivaok.com.br' //prod
}
